import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { getUrlQueryParams } from '../../constant/constant';

export const fetchCourse = createAsyncThunk(
  'programTimeline/fetchCourse',
  async (param, thunkApi) => {
    let hello = param?.stop;
    delete param?.stop;
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_PROGRAMS,
          wstoken: thunkApi.getState().auth.token
        }
      );
      const selectedCourseId = response.data?.courses?.find((val) => {
        return val?.lastaccess === 1 && val?.coursestatus !== 'Locked';
      });
      const token = thunkApi.getState().auth.token;
      let index = -1;
      const queryParam = getUrlQueryParams();

      if (queryParam?.courseId) {
        index = response.data?.courses?.findIndex(
          (val) => val?.courseid == queryParam?.courseId
        );
      }
      if ((selectedCourseId?.courseid || index > 0) && !hello) {
        await thunkApi.dispatch(
          fetchRecentActivity({
            wstoken: token,
            courseid:
              index > 0
                ? response.data?.courses[index]?.courseid
                : selectedCourseId?.courseid
          })
        );
        return { data: response.data };
      } else {
        if (response.data.courses[0]?.coursestatus !== 'Locked' && !hello) {
          const res = await thunkApi.dispatch(
            fetchSection({
              wstoken: token,
              courseid: response.data?.courses[0]?.courseid
            })
          );
        }

        return { data: response.data };
      }
    } catch (e) {}
  }
);
export const fetchSection = createAsyncThunk(
  'programTimeline/fetchSection',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          wstoken: param.wstoken,
          courseid: param?.courseid,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_PROGRAMS_SECTION
        }
      );
      if (!param?.recent || param?.sectionid) {
        thunkApi.dispatch(
          fetchActivity({
            wstoken: param?.wstoken,
            sectionid: param?.sectionid || response.data.sections[0]?.id
          })
        );
      }

      return { data: response.data };
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);
export const fetchActivity = createAsyncThunk(
  'programTimeline/fetchActivity',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_PROGRAMS_SECTION_ACTIVITY
        }
      );
      return { data: response.data };
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);
export const fetchAbout = createAsyncThunk(
  'programTimeline/fetchAbout',
  async (param) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_PROGRAM_DETAILS
        }
      );
      return { data: response.data };
    } catch (e) {}
  }
);

export const markCourseActivity = createAsyncThunk(
  'programTimeline/markCourseActivity',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wstoken: thunkApi.getState().auth.token,
          wsfunction: MOODLE_BACKEND_ROUTES.MARK_RECENT_ACTIVITY
        }
      );
      return { data: response.data };
    } catch (e) {}
  }
);

export const fetchRecentActivity = createAsyncThunk(
  'programTimeline/fetchRecentActivity',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_RECENT_ACTIVITY
        }
      );
      if (response?.data?.modules?.length) {
        const token = thunkApi.getState().auth.token;

        thunkApi
          .dispatch(
            fetchSection({
              wstoken: token,
              courseid: param?.courseid,
              recent: true
            })
          )
          .then((res) => {
            thunkApi.dispatch(
              fetchActivity({
                wstoken: token,
                sectionid: response?.data?.modules[0]?.sectionid
              })
            );
          });
      }
      return { data: response.data };
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const programTimeline = createSlice({
  name: 'programTimeline',
  initialState: {
    loading: true,
    aboutLoading: true,
    sectionLoading: true,
    activityLoading: true,
    recentActivityLoading: true,
    selectedSectionId: 0,
    recentActivityData: [],
    courseData: [],
    aboutData: [],
    activityData: [],
    sectionData: [],
    alreadySelected: true
  },
  reducers: {
    resetState: (state) => {
      state.loading = true;
      state.aboutLoading = true;
      state.sectionLoading = true;
      state.activityLoading = true;
      state.recentActivityLoading = true;
      state.selectedSectionId = 0;
      state.recentActivityData = [];
      state.courseData = [];
      state.aboutData = [];
      state.activityData = [];
      state.sectionData = [];
      state.alreadySelected = true;
    },
    setState: (state, action) => {
      return { ...state, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCourse.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCourse.fulfilled, (state, action) => {
      state.loading = false;
      state.courseData = action.payload?.data?.courses || [];
    });
    builder.addCase(fetchCourse.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(fetchSection.pending, (state) => {
      state.sectionLoading = true;
      state.activityLoading = true;
    });
    builder.addCase(fetchSection.fulfilled, (state, action) => {
      state.sectionLoading = false;
      state.sectionData = action.payload?.data?.sections || [];
    });
    builder.addCase(fetchSection.rejected, (state) => {
      state.sectionLoading = false;
    });
    builder.addCase(fetchActivity.pending, (state) => {
      state.activityLoading = true;
      state.activityData = [];
    });
    builder.addCase(fetchActivity.fulfilled, (state, action) => {
      state.activityLoading = false;
      state.activityData = action.payload?.data?.activities || [];
    });
    builder.addCase(fetchActivity.rejected, (state) => {
      state.activityLoading = false;
    });
    builder.addCase(fetchAbout.pending, (state) => {
      state.aboutLoading = true;
    });
    builder.addCase(fetchAbout.fulfilled, (state, action) => {
      state.aboutLoading = false;
      state.aboutData = action.payload?.data || {};
    });
    builder.addCase(fetchAbout.rejected, (state) => {
      state.aboutLoading = false;
    });
    builder.addCase(fetchRecentActivity.pending, (state) => {
      state.recentActivityLoading = true;
      state.alreadySelected = false;
    });
    builder.addCase(fetchRecentActivity.fulfilled, (state, action) => {
      state.recentActivityLoading = false;
      state.recentActivityData = action.payload?.data?.modules || [];
      if (action?.payload?.data?.errorcode?.length) {
        state.sectionLoading = false;
        state.activityLoading = false;
      }
    });
    builder.addCase(fetchRecentActivity.rejected, (state) => {
      state.recentActivityLoading = false;
    });
  }
});

export const { resetState, setState } = programTimeline.actions;

export default programTimeline.reducer;
